export default "<span class=\"iconify\" [attr.data-icon]=\"iconName\" data-inline=\"false\"></span>\r\n"